<div class="card-resource">
    <div class="card-box">
        <div class="card-green-shadow"></div>
        <div class="card-container">
            <div class="card-container-image">
                <img [src]="resource.image" class="resource-author-image" alt="Author Image">
            </div>
            <div class="card-container-content">
                <div class="resource-date">{{ resourceDate(resource.date) }}</div>
                <div class="resource-title">{{ resource.title }}</div>
                <div class="resource-author-name-wrapper">
                    <span class="resource-author-with">with</span>
                    <span class="resource-author-name">{{ resource.name }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="card-description">
        <div class="resource-description">{{ resource.description }}</div>
        <div class="resource-button-wrapper">
            <a [routerLink]="resourceLink" class="resource-button">Watch Now</a>
        </div>
    </div>
</div>
